'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Row_module = require('../styles/Row.module.less.js');
var Cell = require('./Cell.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const Row = (props) => {
    const { row, className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Row_module.default);
    return (React__namespace.createElement("tr", { className: cx(className, 'row'), "data-qa": "Row", ...restProps }, row.getVisibleCells().map((cell) => (React__namespace.createElement(Cell.Cell, { key: cell.id, cell: cell })))));
};

exports.Row = Row;
//# sourceMappingURL=Row.js.map
